// Mirrors backend csv_importer.night_shift_breakdown():
// regular night hrs × rate + overtime night hrs × rate × 1.5,
// where overtime night hrs = min(night hours, overtime hours).
export function nightShiftBreakdown(row) {
    const hours = Math.max(Number(row.night_shift_hours) || 0, 0);
    const rate = Math.max(Number(row.night_shift_differential_rate) || 0, 0);
    const otNight = Math.min(hours, Math.max(Number(row.overtime_hours) || 0, 0));
    const regNight = hours - otNight;
    const regularAmount = Math.round(regNight * rate * 100) / 100;
    const overtimeAmount = Math.round(otNight * rate * 1.5 * 100) / 100;
    return {
        hours,
        rate,
        regNight,
        otNight,
        regularAmount,
        overtimeAmount,
        total: hours && rate ? Math.round((regularAmount + overtimeAmount) * 100) / 100 : 0,
    };
}

const fmtHours = (h) => (Number.isInteger(h) ? String(h) : h.toFixed(2));

// Compact transparency line for the Reports table, e.g. "78 h × $2.50/hr · 40 + 38 OT".
// Returns null for legacy / manual reports that carry no night hours or rate.
export function nightShiftSummary(row) {
    const bd = nightShiftBreakdown(row);
    if (bd.hours <= 0 || bd.rate <= 0) return null;
    let text = `${fmtHours(bd.hours)} h × $${bd.rate.toFixed(2)}/hr`;
    if (bd.otNight > 0 && Math.abs(bd.total - (Number(row.night_shift_diff) || 0)) < 0.01) {
        text += ` · ${fmtHours(bd.regNight)} + ${fmtHours(bd.otNight)} OT`;
    }
    return text;
}
